import axios from "axios";
import constants from "../../constants/constants";
import { COOKIE, deleteCookie, getCookie } from "../cookie";
/**
 * @name fetchAdminApi
 * @description will fet the data based on params supplied
 * @param {string} param
 * @param {string} method
 * @param {object} variables
 */
export const fetchAdminApi = (param = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${constants.AdminApiUrl}${param}`,
		data: variables,
		headers: {
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
	})
		.then((res) => {
			return res.data;
		})
		.catch((err)=>{
			let { status } = err.response;
			if (status === 401) {
				console.log("Error", err.response.data);
				if(err.response.data.error_message==="Invalid token"){
					deleteCookie(COOKIE.UserId, "/");
					deleteCookie(COOKIE.Token,"/");
					window.location.href = constants.BaseUrl + "/admin-login";
				}
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} 
		})

//Function to call student API.
export const fetchApi = (param = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${constants.ApiUrl}${param}`,
		data: variables,
		headers: {
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
	})
		.then((res) => {
			return res.data;
		})
		.catch((err)=>{
			let { status } = err.response;
			if (status === 401) {
				console.log("Error", err.response.data);
				if(err.response.data.error_message==="Invalid token"){
					localStorage.clear();
					deleteCookie(COOKIE.UserId, "/");
					deleteCookie(COOKIE.Token,"/");
          if(process.env.REACT_APP_ENV==="staging"){
            window.location.href = constants.StagingWebsiteURL;
          }else{
            window.location.href = constants.LiveWebsiteURL;
          }
				}
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} 
		})

export const fetchFileTypeApi = (param = null, method = null, variables = null, fileType = null) =>
	axios({
		method: method,
		url: `${constants.ApiUrl}${param}`,
		data: variables,
		headers: {
			'Content-Type': fileType === "video" ? 'video/mp4': 'audio/mpeg',
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
		responseType: 'blob',
	})
		.then((response) => {
			if (response.status === 200) {
				return response.data; // Return the Blob directly
			} else {
				throw new Error(fileType === "video" ?'Failed to fetch video':'Failed to fetch audio');
			}
		})
		.catch((err) => {
			let { status } = err.response;
			if (status === 401) {
				console.log("Error", err.response.data);
				if (err.response.data.error_message === "Invalid token") {
					deleteCookie(COOKIE.UserId, "/");
					deleteCookie(COOKIE.Token, "/");
					if (process.env.REACT_APP_ENV === "staging") {
						window.location.href = constants.StagingWebsiteURL;
					} else {
						window.location.href = constants.LiveWebsiteURL;
					}
				}
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			}
		})
export const downloadAdminFile = (param = null, method = null, variables = null) =>
	axios({
		method,
		url: `${constants.AdminApiUrl}${param}`,
		data: variables,
		responseType: 'blob',
		headers: {
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
	})
		.then(res => res.data)
		.catch((err) => {
			let { status } = err.response;
			if (status === 401) {
				console.log("Error", err.response.data);
				if (err.response.data.error_message === "Invalid token") {
					deleteCookie(COOKIE.UserId, "/");
					deleteCookie(COOKIE.Token, "/");
					if (process.env.REACT_APP_ENV === "staging") {
						window.location.href = constants.StagingWebsiteURL;
					} else {
						window.location.href = constants.LiveWebsiteURL;
					}
				}
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			}
		});